package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("input_height")
data class HeightInputScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("default_hint") val defaultHint: String? = null,
    @SerialName("non_empty_hint") val nonEmptyHint: String? = null,
    @SerialName("min_height_cm") val minHeightCm: Int = 0,
    @SerialName("max_height_cm") val maxHeightCm: Int = Int.MAX_VALUE,
    @SerialName("min_height_ft") val minHeightFt: Int = 0,
    @SerialName("max_height_ft") val maxHeightFt: Int = Int.MAX_VALUE,
) : ScreenConfig